import { CelumPropertiesProvider } from '@celum/core/configuration';

/** Apps every licensed user may open. The experience privilege only Curators get is not checked for them. */
const APPS_WITHOUT_PRIVILEGE_CHECK = ['experience', 'formats'];

export function currentAppShouldSkipLicensePrivilegeCheck(): boolean {
  return APPS_WITHOUT_PRIVILEGE_CHECK.includes(CelumPropertiesProvider.properties.applicationName);
}
